var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurundi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#62af3f",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15 12 30 0H0zm0 0L0 24h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m27.5 0-8.9 7.2a6 6 0 0 0-7.2 0L2.5 0H0v2l9.53 7.55a6 6 0 0 0 0 4.9L0 22v2h2.5l8.9-7.2a6 6 0 0 0 7.2 0l8.9 7.2H30v-2l-9.53-7.54a6 6 0 0 0 0-4.92L30 2V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b92932",
    d: "M15.48 8.32 15 7.5l-.48.82h-.95l.48.83-.48.83h.95l.48.82.48-.82h.95l-.48-.83.48-.83zm3.05 5.37.47-.82h-.95l-.48-.83-.47.83h-.95l.47.82-.47.83h.95l.47.82.48-.82H19zm-5.63-.82-.47-.83-.48.83H11l.47.82-.48.83h.96l.48.82.47-.82h.95l-.47-.83.47-.82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurundi);
export default __webpack_public_path__ + "static/media/burundi.a9371e47e6bc4e1136070c45fc946a7f.svg";
export { ForwardRef as ReactComponent };